export const topTiers = [
    {
        name: "Solaris",
        range: "500K-1M",
        color: "from-cyan-300 to-cyan-500",
        description:
            "Sua presença é forte, você brilha com energia e clareza. O mercado sente seu impacto, você está se tornando referência.",
        image: '/assets/awards/cackto_500k_1m.png',
        code: "solaris",
        min_value: 500000,
        max_value: 1000000,
    },
    {
        name: "Imperium",
        range: "1M - 5M",
        color: "from-gray-300 to-gray-500",
        description:
            "Um império construído com estratégia, consistência e paixão. A Cakto vai além para reconhecer esse feito.",
        image: '/assets/awards/cackto_1m_5m.png',
        code: "imperium",
        min_value: 1000000,
        max_value: 5000000,
    },
    {
        name: "Golden Desert",
        range: "5M - 10M",
        color: "from-green-300 to-green-500",
        description: "Sua história se torna eterna. Um legado construído com visão e excelência.",
        image: '/assets/awards/cackto_5m_10m.png',
        code: "golden",
        min_value: 5000000,
        max_value: 10000000,
    },
    {
        name: "Supreme Sun",
        range: "10M +",
        color: "from-red-400 to-red-600",
        description:
            "O ápice da jornada! Você não atravessou o deserto, você se tornou o sol que o ilumina. Essa é a maior honra da Cakto, reservada aos que desafiaram todos os limites.",
        image: '/assets/awards/cackto_10m_20m.png',
        code: "sun",
        min_value: 10000000,
        max_value: null,
    },
]

export const bottomTiers = [
    {
        name: "Início",
        range: "0 - 10K",
        color: "from-yellow-600 to-yellow-800",
        description:
            "Criamos um caminho épico: um jogo de missões e recompensas reais, onde cada conquista é celebrada como deve ser.\nUm sistema feito para valorizar sua jornada, passo a passo.",
        isCurrent: true,
        image: '/assets/awards/cackto_0_10k.png',
        code: "beginner",
        min_value: 0,
        max_value: 10000,
    },
    {
        name: "Mirage",
        range: "10K - 100K",
        color: "from-green-400 to-green-600",
        description:
            "É aqui que tudo começa. Ao alcançar R$10 mil em vendas, você desbloqueia sua primeira recompensa: pulseiras oficiais Cakto e uma caixinha exclusiva, símbolos da sua entrada no jogo.",
        image: '/assets/awards/cackto_10k_100k.png',
        code: "mirage",
        min_value: 10000,
        max_value: 100000,
    },
    {
        name: "Oasis",
        range: "100K - 250K",
        color: "from-gray-300 to-gray-500",
        description:
            "Aqui você recarrega suas forças, vê os resultados surgirem, e entende que está trilhando o caminho certo.",
        image: '/assets/awards/cackto_100k_250k.png',
        code: "oasis",
        min_value: 100000,
        max_value: 250000,
    },
    {
        name: "Dune",
        range: "250K - 500K",
        color: "from-yellow-300 to-yellow-500",
        description:
            "Esse é o estágio onde a constância vence o cansaço. Aqui, sua marca começa a ecoar. Novas recompensas se aproximam. Prepare-se.",
        image: '/assets/awards/cackto_250k_500k.png',
        code: "dune",
        min_value: 250000,
        max_value: 500000,
    },
]

export const billingLevels = [
    {
        name: "Início",
        code: "beginner",
        min_value: 0,
        max_value: 10000,
        color: "from-yellow-400 to-amber-600",
        bgColor: "bg-gradient-to-r from-amber-900/20 to-yellow-900/20",
        textColorDark: "text-white",
        textColor: "text-white",
        borderColor: "border-amber-500/50",
        backgroundImage: "/assets/billing/Billing_0_10.png",
        progressStyle: {
            background: "radial-gradient(99.97% 100% at 37.5% 0%, #FFFFFF 0%, #8F672E 22.92%, #F5E2C7 54.02%, #BD9867 76.92%, #A8814C 87.5%, #F5E2C7 100%)",
            border: "1px solid #D7B583",
            borderRadius: "500px",
            height: "10px",
        },
    },
    {
        name: "Mirage",
        code: "mirage",
        min_value: 10000,
        max_value: 100000,
        color: "from-emerald-400 to-green-600",
        bgColor: "bg-gradient-to-r from-emerald-900/20 to-green-900/20",
        textColorDark: "text-white",
        textColor: "text-white",
        borderColor: "border-emerald-500/50",
        backgroundImage: "/assets/billing/Billing_10_100.png",
        progressStyle: {
            background: "radial-gradient(99.97% 100% at 37.5% 0%, #438049 0%, #A8CCAC 22.92%, #EEEEEE 54.02%, #7DA881 76.92%, #5C8D61 87.5%, #A8CCAC 100%)",
            border: "1px solid #3A783F",
            borderRadius: "500px",
            height: "10px",
        },
    },
    {
        name: "Oasis",
        code: "oasis",
        min_value: 100000,
        max_value: 250000,
        color: "from-gray-400 to-slate-600",
        bgColor: "bg-gradient-to-r from-gray-900/20 to-slate-900/20",
        textColorDark: "text-white",
        textColor: "text-white",
        borderColor: "border-gray-500/50",
        backgroundImage: "/assets/billing/Billing_100_250.png",
        progressStyle: {
            background: "radial-gradient(99.97% 100% at 37.5% 0%, #9A9A9A 0%, #ECECEC 22.92%, #EEEEEE 54.02%, #9F9F9F 76.92%, #EFF4F1 87.5%, #ADADAD 100%)",
            border: "1px solid #C6C6C6",
            borderRadius: "500px",
            height: "10px",
        },
    },
    {
        name: "Dune",
        code: "dune",
        min_value: 250000,
        max_value: 500000,
        color: "from-amber-400 to-yellow-600",
        bgColor: "bg-gradient-to-r from-yellow-900/20 to-amber-900/20",
        textColorDark: "text-white",
        textColor: "text-white",
        borderColor: "border-yellow-500/50",
        backgroundImage: "/assets/billing/Billing_250_500.png",
        progressStyle: {
            background: "radial-gradient(104.99% 105% at 35.94% -5%, #E0D77A 5.29%, #AD9208 22.92%, #F7F7EB 60.14%, #DAD171 76.92%, #E7ECD3 87.5%, #A38701 100%)",
            boxShadow: "0px 4px 4px rgba(241, 241, 130, 0.15)",
            borderRadius: "500px",
            height: "10px",
        },
    },
    {
        name: "Solaris",
        code: "solaris",
        min_value: 500000,
        max_value: 1000000,
        color: "from-blue-400 to-cyan-600",
        bgColor: "bg-gradient-to-r from-cyan-900/20 to-blue-900/20",
        textColorDark: "text-white",
        textColor: "text-black",
        borderColor: "border-cyan-500/50",
        backgroundImage: "/assets/billing/Billing_500_1m.png",
        progressStyle: {
            background: "radial-gradient(96.59% 96.67% at 40.62% 3.33%, #FFFFFF 0%, #F5F9FA 22.92%, #55BED8 60.14%, #C7EFF9 76.92%, #EFF3F4 87.5%, #A2CBD5 100%)",
            boxShadow: "0px 4px 4px rgba(22, 29, 79, 0.25)",
            borderRadius: "500px",
            height: "10px",
        },
    },
    {
        name: "Imperium",
        code: "imperium",
        min_value: 1000000,
        max_value: 5000000,
        color: "from-slate-300 to-gray-500",
        bgColor: "bg-gradient-to-r from-gray-800/20 to-slate-800/20",
        textColorDark: "text-white",
        textColor: "text-white",
        borderColor: "border-gray-400/50",
        backgroundImage: "/assets/billing/Billing_1m_5m.png",
        progressStyle: {
            background: "radial-gradient(99.97% 100% at 37.5% 0%, #383838 0%, #ECECEC 22.92%, #A2A0A0 54.02%, #585858 76.92%, #EFF4F1 87.5%, #383838 100%)",
            border: "1px solid #FFFFFF",
            borderRadius: "500px",
            height: "10px",
        },
    },
    {
        name: "Golden Desert",
        code: "golden",
        min_value: 5000000,
        max_value: 10000000,
        color: "from-green-400 to-emerald-500",
        bgColor: "bg-gradient-to-r from-emerald-900/20 to-green-900/20",
        textColorDark: "text-white",
        textColor: "text-white",
        borderColor: "border-emerald-400/50",
        backgroundImage: "/assets/billing/Billing_5m_10m.png",
        progressStyle: {
            background: "radial-gradient(96.59% 96.67% at 40.62% 3.33%, #E0FF15 0%, #66F14D 22.6%, #FFFFFF 39.9%, #0EFE6E 69.71%, #E4F5F1 87.5%, #38AE67 100%)",
            borderRadius: "99px",
            height: "10px",
        },
    },
    {
        name: "Supreme Sun",
        code: "sun",
        min_value: 10000000,
        max_value: null,
        color: "from-pink-400 to-red-600",
        bgColor: "bg-gradient-to-r from-red-900/20 to-pink-900/20",
        textColorDark: "text-white",
        textColor: "text-white",
        borderColor: "border-red-500/50",
        backgroundImage: "/assets/billing/Billing_10m.png",
        progressStyle: {
            background: "radial-gradient(96.59% 96.67% at 40.62% 3.33%, #FF5715 0%, #D00909 22.6%, #F2E2E2 39.9%, #FE0E0E 69.71%, #E4F5F1 87.5%, #940000 100%)",
            borderRadius: "500px",
            height: "10px",
        },
    },
]